import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Button, Paper, Radio, RadioGroup, FormControlLabel } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import { useGetListConsumerMutation, useGetListQRLocationMutation } from '../services/consumer';
import LoadingPage from './loadingPage';
import AlertSnackbar from './alertSnackbar';
import "react-day-picker/style.css";
import moment from 'moment';
import DateRange from './tools/daterange';
import AutocompleteWithAll from './tools/autocompleteWithAll';
// import CustomTable from './tools/customTable';
const API_URI = process.env.REACT_APP_API_URI;

export default function ConsumerList() {
  const [getListQRLocation, listQRLocationResult] = useGetListQRLocationMutation();
  const [getData, dataResult] = useGetListConsumerMutation();
  const [listQRLocation, setListQRLocation] = useState([]);
  const [dataLoaded, setDataLoaded] = useState([]);
  const [columns, setCoumns] = useState([]);
  const [locationItem, setLocationItem] = useState({value: 0, label: 'All'});
  const [gridHeight, setGridHeight] = useState(300);
  const [snackContent, setSnackContent] = useState("");
	const [range, setRange] = useState({from: moment().startOf('month'), to: moment()});
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [viewDetail, setViewDetail] = useState(0);
  const gridRef = useRef();
  const [pinnedBottomRowData, setPinnedBottomRowData] = useState([
      { make: 'Total', model: '', TOTAL: 0 }
  ]);

  ModuleRegistry.registerModules([ AllCommunityModule ]);
  useEffect(() => {
    getListQRLocation({location: 'group'});
    handleGridHeight();
  }, []);

  useEffect(() => {
    handleGridHeight();
  }, [selectedOptions]);

  const handleGridHeight = () =>{
    const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?divHeader.clientHeight:0) - 72);
  }

  useEffect(() => {
    if(listQRLocationResult && listQRLocationResult.data){
      const dt = JSON.parse(listQRLocationResult.data);
      let st = [];
      // st.push({value: 0, label: 'All'})
      dt.map(m=>{
        st.push({value: m.CODE, label: m.LOCATION})
      })
      setListQRLocation(st);
    }
  }, [listQRLocationResult]);

  useEffect(() => {
    if(dataResult.data)
    {
      const dt = JSON.parse(dataResult.data);
      setDataLoaded(dt);
      if(dt.length > 0)
        getCoumns(dt[0]);
      updatePinnedBottomRow(null, dt);
    }
  }, [dataResult]);

  const getDataView=()=>{
    if(!range) return;
    const ids = selectedOptions.map(m=>m.value);
    getData({"ids": ids.toString(), "fromDate": moment(range.from).format('YYYY-MM-DD')
      , "toDate": moment(range.to).format('YYYY-MM-DD'), "type": viewDetail});
    handleGridHeight();
    gridRef.current.setFilterModel(null);
  }

  const getCoumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key,
        filter: true,
        cellStyle: () => ((key=="TOTAL" || key=="FEMALE" || key=="MALE" || key=="OTHER")
        ?{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
          fontWeight: key=="TOTAL" ? "bold" : ""
        }:null),
        valueFormatter: params => (key=="CREATED_AT")
                      && params.data[key]?moment(params.data[key]).format("YYYY-MM-DD HH:mm"):params.data[key]
      }
    });
    setCoumns(cols);
  }

  const onGridReady = useCallback((params) => {
    gridRef.current = params.api;
    updatePinnedBottomRow(params.api); // Initial calculation
  }, []);

  const updatePinnedBottomRow = (api, data) => {
    let TOTAL = 0, FEMALE = 0, MALE = 0, OTHER = 0;
    if(data)
      data.map(m=>{
        TOTAL += m.TOTAL;
        FEMALE += m.FEMALE;
        MALE += m.MALE;
        OTHER += m.OTHER;
      })
    else
      api.forEachNodeAfterFilter((node) => {
          TOTAL += node.data.TOTAL;
      });
    setPinnedBottomRowData([{ make: 'Total', model: '', TOTAL: TOTAL, FEMALE: FEMALE, MALE: MALE, OTHER: OTHER }]);
  };

  const onFilterChanged = useCallback(() => {
    if (gridRef.current) {
        updatePinnedBottomRow(gridRef.current);
    }
  }, []);

  const exportExcel=()=>{
    const ids = selectedOptions.map(m=>m.value);
    window.open(`${API_URI}/consumer/exporttoexcel?ids=${ids}&fromdate=${ moment(range.from).format('YYYY-MM-DD')}&todate=${ moment(range.to).format('YYYY-MM-DD')}&type=${viewDetail}`, '_blank', 'noopener,noreferrer');
  }

  const getRowClass = useCallback(params => {
    if (params.node.rowIndex % 2 === 1) {
        return "grid-odd-rows";
    }
    if (params.node.rowPinned === 'bottom') {
      return "text-bold";
    }
  }, []);

  const myTheme = themeQuartz.withParams({
    // borderColor: "#9696C8",
    wrapperBorder: false,
    headerRowBorder: false,
    // rowBorder: { style: "dotted", width: 1 },
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  const onChangeLocation=(e)=>{
    setLocationItem(e);
  }

  return (
    <div style={{padding: '0 10px'}}>
      { (listQRLocationResult.isLoading || dataResult.isLoading) && <LoadingPage /> }
      <div style={{marginTop: '20px'}}>
        <div id='divHeader' style={{float: 'left'}}>
          {/* <Autocomplete
            disablePortal
            size="small"
            options={listQRLocation}
            // getOptionLabel={(option) => option.label}
            sx={{ width: 350, float: 'left', marginRight: '10px', marginBottom: '10px' }}
            onChange={(e, item)=>onChangeLocation(item||locationItem)}
            value={locationItem}
            renderInput={(params) => <TextField {...params} label="Location" />}
            loading={listQRLocationResult.isLoading}
          /> */}
          <AutocompleteWithAll options={listQRLocation}
            props_sx={{ width: 'auto', minWidth: '200px', float: 'left', marginRight: '10px', marginBottom: '10px' }}
            props={{label: 'Location', placeholder: 'Select Location'}}
            selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} />
          <div style={{float: 'left', display: 'flex'}}>
            <DateRange range={range} setRange={setRange} sx={{float: 'left'}} />
            <RadioGroup
              sx={{ marginLeft: '10px' }}
              aria-labelledby="gender-radio-group-label"
              id="gender"
              name="gender"
              value={viewDetail}
              onChange={(e)=>setViewDetail(e.target.value)}
              row // Optional: Arranges radio buttons horizontally
            >
              <FormControlLabel value="0" control={<Radio />} label="Total" />
              <FormControlLabel value="1" control={<Radio />} label="Detail" />
            </RadioGroup>
            <Button variant="contained" onClick={getDataView}
              sx={{ marginRight: '10px', marginBottom: '10px', marginLeft: '10px', float: 'left' }}>View</Button>
            <Button variant="contained" onClick={exportExcel}
              sx={{ marginRight: '10px', marginBottom: '10px', float: 'left' }}>Export</Button>
          </div>
        </div>
        <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
          <AgGridReact
            rowData={dataLoaded}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={500}
            paginationPageSizeSelector={[200, 500, 1000]}
            pinnedBottomRowData={pinnedBottomRowData}
            getRowClass={getRowClass}
            theme={theme}
            onGridReady={onGridReady}
            onFilterChanged={onFilterChanged}
          />
        </Paper>
        {/* <CustomTable /> */}
      </div>

      <AlertSnackbar message={snackContent} setSnackContent={setSnackContent}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} />
    </div>
  )
}